// extracted by mini-css-extract-plugin
export default {"root":"footer_root__Mgewo","mainSectionFooter":"footer_mainSectionFooter__bhsBZ","mainSectionFooter__card":"footer_mainSectionFooter__card__2o7hI"};